/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowARightIcon16Solid = forwardRef('ArrowARightIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M8.32 3.962a1.25 1.25 0 1 1 1.767-1.768l3.928 3.928a2.656 2.656 0 0 1 0 3.756l-3.928 3.928a1.25 1.25 0 0 1-1.768-1.768l2.788-2.788H2.5a1.25 1.25 0 1 1 0-2.5h8.607L8.32 3.962Z" })));
});
